<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>商城</span></p>
        <div class="artcle-box">
            
            <div class="artcle-right" >
                <div class="search-page">
                    <Search class="searchInput"  @inputKey="inputKey"></Search>
                  
                    <el-button type="primary" round @click="company()" >购物车</el-button>
                    
                </div>
                <div class="enable-list">
                    <div v-for="item in exableList.items" :key="item.id" class="list-item" @click="handleExableInfo(item)">
                        <div :style="'width: 370px; height: 300px;background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                        <p class="description" style="height: 45px;">{{item.name}}</p>
                            <p style="height: 20px;">{{item.company_name}}</p>
                            <p>编码型号：CG8894</p>
                            <!-- <p>制造商型号：10172476</p> -->
                            <div class="enableFh">
                                <!-- <div>当日发货</div> -->
                                <div>{{item.att_item_price_size}}种规格</div>
                            </div>
                            <div class="price" v-if="IsToken">
                                <div>
                                    <p class="colorProce"><span>￥</span>{{item.price}} </p>
                                    <span>/{{ item.unit }}</span> 
                                    <!-- <div class="vipPrice"><p>￥20.99</p>会员价</div> -->
                                </div>
                                <!-- <div>
                                    <i class="el-icon-circle-plus" style="cursor: pointer;"></i>
                                </div> -->
                            </div>
                    </div>
                    
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
                
            </div>
           
        </div>
    </div>
</template>

<script>
import Search from "../search/index.vue"
export default({
    data(){
        return{
            itemSub: [],
            subName: '',
            currentName: '',
            sort_type: 'uni',
            product_types: [ 'product','jifen','service'],
            sort_value: 0,
            exableList: [],
            cate: '',
            s_sub_cate: '',
            sub_cate: '',
            keywords: '',
            hideOnSinglePage: true,
            total: 0,
            itemCate: '',
            widthNew: false,
            IsToken: false
        }
    },
    components: {
        Search,
    },
    watch: {
        
      
    },
    methods:{
        
        company(){
            this.$router.push({
                path: '/cart'
            })
        },  

        inputKey(val){
            this.keywords = val
            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: '',
                sub_cate: '',
                s_sub_cate: '',
                keywords: val,
                product_types: [ 'product','jifen','service'],
                sort_type: 'uni',
                sort_value: '0',
            }
            this.gesListEnable(items)

        },
      
        gesListEnable(data){
            this.$store.dispatch('enable/listproduct',data)
                .then(res => {
                    if(res.ok){
                        this.exableList = res.data
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }

                    }
                })
        },
      
        
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let items = {
                pageNum: val,
                pageSize: 20,
                cate: '',
                sub_cate: '',
                s_sub_cate: '',
                keywords: this.keywords,
                product_types: [ 'product','jifen','service'],
                sort_type: 'uni',
                sort_value: '0',
            }
            this.gesListEnable(items)
        },
        handleExableInfo(item){
            console.log(item);
            
            const { href } = this.$router.resolve({
                path: "/enableInfo",
                query: {
                    id: item.id,
                }
            });
            window.open(href, '_blank');
        }
    },
    mounted(){
        
    },
    
    created(){
        if(localStorage.getItem('token')){
            this.IsToken = true
        }else{
            this.IsToken = false
        }
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let items = {
            pageNum: 1,
            pageSize: 20,
            cate: '',
            sub_cate: '',
            s_sub_cate: '',
            keywords: '',
            product_types: [ 'product','jifen','service'],
            sort_type: 'uni',
            sort_value: '0',
        }
        this.gesListEnable(items)
        
    }
})
</script>

<style scoped lang="scss">
.artcleMain{
    width: 1200px;
    padding: 10px 10px;
    margin: 45px auto;
}
.current{
    margin-top: -45px;
    font-size: 17px;
    color: #333;
}
.current span{
    font-size: 16px;
    cursor: pointer;
    color: #666666;
}
.artcle-box{
    width: 1200px;
    
}

.artcle-right{
    width: 1200px;
    background: #fff;
    margin-left: 0px;
    /* padding: 10px 10px ; */
    /* line-height: 45px; */
}

.search-page{
    height: 50px;
    display: flex;
    justify-content: space-between;
}
.searchInput{
    width: 650px;
}

.search-page .el-button{
    /* height: 42px; */
    background: #ff9828;
    border: 1px solid #ff9828;
}
.enable-list{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    cursor: pointer;
    .list-item{
        width: 370px;
        margin: 10px 6px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        font-size: 14px;
        color: #999999;
        padding: 5px 5px 8px 5px;
        .commodityImage{
            width: 285px;
            height: 300px;
        }
        .description{
    
            margin: 10px 0 10px 0;
            color: #333;
            font-size: 18px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            
        }
        .enableFh{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;
            div{
                margin-right: 10px;
                padding: 3px 5px;
                background: #ffe9c2;
                color: #333;
            }
            
        }
        .price{
            display: flex;
            justify-content: space-between;
            align-items: end;
            font-size: 16px;
            margin-top: 10px;
            width: 99%;
            div{
                display: flex;
                justify-content: flex-start;
                align-items: end;
                .colorProce{
                    font-size: 18px;
                    color: #ff2f4f;
                }
                .vipPrice{
                    padding-right: 5px;
                    font-size: 14px;
                    margin-left: 10px;
                    color: #fff;
                    border: 1px solid black;
                    background: #000;
                    align-items: center;
                    p{
                        padding: 2px 3px;
                        border-top-right-radius: 8px;
                        background: #fff;
                        color: #333;
                        margin-right: 5px;
                    }
                }
            }
            span{
                font-size: 14px;
            }
            i{
                color: #00acc9;
                float: right;
            }
        }
        .youhui{
            margin-top: 10px;
            span{
                padding: 3px 5px;
                color: #ff2f4f;
                border: 1px solid #ff2f4f;
            }
        }
    }
}
    
@media screen and (max-width: 540px) {
    .artcleMain{
        width: 96%;
        padding: 10px 0px;
    }
    .current{
        padding: 0 0;
    }
    .artcle-box{
        width: 100%;
        
    }

    .artcle-right{
        width: 100%;
    }

    .search-page{
       
        height: 50px;
        display: flex;
        justify-content: space-between;
    }
    .searchInput{
        margin-left: 10px;
        width: 60%;
    }

    .search-page .el-button{
        /* height: 42px; */
        background: #ff9828;
        border: 1px solid #ff9828;
    }
    .enable-list{
        display: flex;
        justify-content: flex-start;
        flex-flow: row wrap;
        cursor: pointer;
    }
    .list-item{
        width: 340px;height: 450px;
        margin: 20px 25px 0 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        font-size: 14px;
        color: #999999;
        padding: 5px 5px;
    }
    .description{
        
        margin: 10px 0 10px 0;
        color: #333;
        font-size: 18px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        
    }
    .price{
        color: #ff2f4f;
        font-size: 16px;
        margin-top: 20px;
        width: 99%;
    }
    .price span{
        font-size: 14px;
    }
    .price i{
        color: #00acc9;
        float: right;
    }
}
</style>